import React, { useState, useEffect } from "react";
import Icon from "../icon";
import { PopupInner } from "./popupInner";
import styles from "./map.scss";

import ReactMapboxGl, { Layer, Feature, Popup, ZoomControl, Marker, MapContext } from "react-mapbox-gl";
import { LngLatBounds } from "mapbox-gl";
import { isMobile } from "../../common/helpers";

const MapboxMap = ReactMapboxGl({
    accessToken: document.getElementById('app').dataset.mapboxToken,
    scrollZoom: false,
    attributionControl: false,
    maxZoom: 15
});

const Map = ({ currentTour, loading, tours, onSelectTour, onCloseSelectedTour, onMapClose, centerLocation, showUserLocation, onGeoLocation }) => {
    const [center, setCenter] = useState(centerLocation);

    let bounds = null;

    if (tours.length && currentTour !== null && !(currentTour && currentTour.id)) {
        // console.log(currentTour);
        bounds = new LngLatBounds();

        for (let item of tours) {
            bounds.extend([item.lng, item.lat]);
        }

        if (showUserLocation) {
            bounds.extend(showUserLocation);
        }
    }

    return (
        <div className={styles.map}>
            <button className={styles.hideMap} onClick={onMapClose}>{window.tstrings["Bekijk de lijst"]}</button>
            { loading && (
                <div className={styles.mapLoader}>
                    <span>Loading...</span>
                </div>
            )}
            <MapboxMap
                style="mapbox://styles/poppr/ckb6cxu0h3czx1ip9tu45ak3p"
                className={styles.mapWrapper}
                fitBounds={bounds}
                fitBoundsOptions={{ padding: 60 }}
                renderChildrenInPortal={true}
                center={center}
                onStyleLoad={() => {
                    console.log("styles loaded");
                    // setLoading(false);
                }}

            >
                <MapContext.Consumer>
                    {(map) => {
                        // Load event is not triggered here
                        map.on('load', () => {
                            setLoading(false);
                            setCenter(map.getCenter());
                        })

                        // console.log(map);
                        // Hier kijken om dragging te disablen op mobile als currentTour openstaat (niet zeker of dit hier kan)
                        if (isMobile()) {
                            if (currentTour && tours.length) {
                                map.dragPan.disable();
                                document.body.classList.add("popup-open");
                            } else {
                                map.dragPan.enable();
                                document.body.classList.remove("popup-open");
                            }
                        }
                    }}
                </MapContext.Consumer>

                {tours.map((loc) => (
                    <Marker
                        key={loc.id}
                        onClick={onSelectTour(loc)}
                        coordinates={[loc.lng, loc.lat]}
                        anchor="bottom"
                        className={styles.marker}
                        offset={[8, 14]}
                    >
                        <div className={styles.markerInner}>
                            <div className={styles.markerPin}>
                                <Icon name="pin-red" />
                            </div>
                            <div className={styles.markerName}>
                                <span>{loc.name}</span>
                            </div>
                        </div>
                    </Marker>
                ))}

                {showUserLocation && (
                    <Marker
                        key={"userLocation"}
                        coordinates={showUserLocation}
                        className={[styles.marker, styles.markerUserLocation].join(" ")}
                    >
                        <div className={styles.markerInner}>
                            <div className={styles.markerPin}>
                                <Icon name="geolocate" />
                            </div>
                        </div>
                    </Marker>
                )}

                {currentTour && tours.length && (
                    <Popup
                        coordinates={[currentTour.lng, currentTour.lat]}
                        offset={{
                            'bottom': [0, -60],
                            'top': 0,
                            'right': [-30, 0],
                            'bottom-right': [-30, 0],
                            'bottom-left': [30, 0],
                            'left': [30, 0],
                        }}
                    >
                        <PopupInner tour={currentTour} onCloseSelectedTour={onCloseSelectedTour}></PopupInner>
                    </Popup>
                )}
                <button className={styles.btnGeoLocate} onClick={onGeoLocation}>
                    <Icon name="geolocate" />
                </button>
                <ZoomControl position="bottom-right" />
            </MapboxMap>
        </div>
    );
};
export { Map };
